import { ViewNotFound } from '@view/view_not_found/view_not_found_route.component';
import { Route, Routes } from 'react-router';
import { Heading } from './heading.component';
import { ListRoot } from './list_root.component';
import { SelectedAppointmentCase } from './selected_appointment_case.component';
import { SelectedMessagingCase } from './selected_messagingCase.component';

export function FixedRoutes() {
	return (
		<Routes>
			<Route
				path='/'
				element={
					<ListRoot>
						<Heading />
					</ListRoot>
				}
			/>
			<Route path='/video/:callticket' element={<SelectedAppointmentCase />} />
			<Route path='/message/:messageId' element={<SelectedMessagingCase />} />
			<Route path='/*' element={<ViewNotFound />} />
		</Routes>
	);
}
